<div class="split-tickets-conteiner">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="200 400 800 400"
    class="split-ticket-logo"
    role="img"
    id="split-ticket-logo"
    aria-label="Split ticket"
  >
    <path
      d="m867.21 534.91h35.07v-55.734c-34.094 0-61.727-27.629-61.727-61.699h-222.29v39.645c0 10.094-8.1758 18.273-18.273 18.273s-18.273-8.1758-18.273-18.273v-39.645h-222.29c0 34.066-27.629 61.699-61.699 61.699v55.734h35.07c35.777 0 65.094 29.285 65.094 65.094s-29.312 65.094-65.094 65.094h-35.07v55.703c34.066 0 61.699 27.629 61.699 61.727h222.29v-39.703c0-10.094 8.1758-18.273 18.273-18.273s18.273 8.1758 18.273 18.273v39.703h222.29c0-34.094 27.629-61.727 61.727-61.727v-55.703h-35.07c-35.809 0-65.094-29.312-65.094-65.094 0-35.777 29.285-65.094 65.094-65.094zm-248.94 150.82c0 10.094-8.1758 18.273-18.273 18.273s-18.273-8.1758-18.273-18.273v-57.152c0-10.094 8.1758-18.273 18.273-18.273s18.273 8.1758 18.273 18.273zm0-114.27c0 10.094-8.1758 18.273-18.273 18.273s-18.273-8.1758-18.273-18.273v-57.152c0-10.094 8.1758-18.273 18.273-18.273s18.273 8.1758 18.273 18.273z"
    />
  </svg>
  @if (savings && +savings > 0) {
    <span class="split-tickets-text"
      ><strong>Save {{ savings | currency: currency : 'symbol' : '1.2-2' }}</strong></span
    >
  } @else {
    <span i18n="@@splitTicketSplitTickets" class="split-tickets-text">Split Tickets</span>
  }
</div>
